var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChevronsDown(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.39143 10.3913C5.63551 10.1472 6.03124 10.1472 6.27532 10.3913L10 14.116L13.7248 10.3913C13.9688 10.1472 14.3646 10.1472 14.6086 10.3913C14.8527 10.6354 14.8527 11.0311 14.6086 11.2752L10.7366 15.1472C10.3298 15.554 9.67027 15.554 9.26347 15.1472L5.39143 11.2752C5.14735 11.0311 5.14735 10.6354 5.39143 10.3913Z",
    fill: "#5DA196"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.39143 5.39131C5.63551 5.14723 6.03124 5.14723 6.27532 5.39131L10 9.11604L13.7248 5.39131C13.9688 5.14723 14.3646 5.14723 14.6086 5.39131C14.8527 5.63539 14.8527 6.03112 14.6086 6.27519L10.7366 10.1472C10.3298 10.554 9.67027 10.554 9.26347 10.1472L5.39143 6.27519C5.14735 6.03112 5.14735 5.63539 5.39143 5.39131Z",
    fill: "#5DA196"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronsDown);
export default __webpack_public_path__ + "static/media/chevrons-down.67986e7cc6bf34c53218de89865e82e1.svg";
export { ForwardRef as ReactComponent };